(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["schnorv-bundle"] && !Shopify.designMode) return;
  try {
    (function () {
    function apply(root) {
      var checked = root.querySelector('input[data-sb-variant]:checked');
      if (!checked) return;
      var section = root.closest('.shopify-section') || document;
      section.querySelectorAll('product-form-component input[name="id"]').forEach(function (input) {
        input.value = checked.getAttribute('data-sb-variant');
      });
      root.querySelectorAll('[data-sb-opt]').forEach(function (label) {
        label.classList.toggle('is-selected', label.contains(checked));
      });
      syncSticky(checked);
      applySetMedia(root);
    }

    // Galerie auf das Bild des gewählten Sets schieben. Beim Laden bewusst nicht, damit der
    // Erstbesucher das neutrale Hauptbild sieht und nicht ohne Zusammenhang zwei Kissen.
    // Set-Bilder aus dem normalen Karussell nehmen: Slide + zugehörige Thumbnails verstecken.
    // Sichtbar wird immer nur das Bild des gerade gewählten Sets — und auch das erst nach einem Klick.
    // Das Bild des gewaehlten Sets soll sich wie ein ganz normales Karussell-Bild verhalten:
    // als erstes Bild sichtbar, im Vorschaustreifen anklickbar und im Vollbild an derselben Stelle.
    //
    // Umgesetzt durch TAUSCH DER BILDQUELLEN, nicht durch Umsortieren: Die Vorschaubildchen rufen
    // eine fest einprogrammierte Position auf (on:click="/select/3"), ein Verschieben im Quelltext
    // wuerde diese Zuordnung zerreissen. Also zeigt Dia 1 das Set-Bild, und das Set-Dia zeigt das
    // bisherige Dia 1. Beide bleiben erreichbar, die Positionen stimmen weiterhin.
    //
    // Die beiden nicht gewaehlten Set-Bilder bleiben ausgeblendet - in der Galerie UND im Vollbild.
    function applySetMedia(root) {
      var gallery = document.querySelector('.product-information__media media-gallery');
      if (!gallery) return;

      var gruppen = [
        { eintraege: gallery.querySelectorAll('slideshow-slide') },
        { eintraege: gallery.querySelectorAll('.slideshow-controls__thumbnail') },
        { eintraege: document.querySelectorAll('.dialog-zoomed-gallery > li') },
        { eintraege: document.querySelectorAll('.dialog-thumbnails-list__thumbnail') }
      ].filter(function (g) { return g.eintraege.length; });
      if (!gruppen.length) return;

      var checked = root.querySelector('input[data-sb-variant]:checked');
      var aktiv = checked ? parseInt(checked.getAttribute('data-sb-media-index'), 10) : -1;
      var gewaehlt = !!root.dataset.sbUserPicked && !isNaN(aktiv) && aktiv >= 0;

      function merken(img) {
        if (!img || img.dataset.sbOrig !== undefined) return;
        img.dataset.sbOrig = img.getAttribute('src') || '';
        img.dataset.sbOrigSet = img.getAttribute('srcset') || '';
      }
      function setzen(img, src, srcset) {
        if (!img || !src) return;
        merken(img);
        if (img.getAttribute('src') === src) return;
        img.setAttribute('src', src);
        if (srcset) img.setAttribute('srcset', srcset); else img.removeAttribute('srcset');
      }
      function zurueck(img) {
        if (!img || img.dataset.sbOrig === undefined) return;
        setzen(img, img.dataset.sbOrig, img.dataset.sbOrigSet);
      }

      var setIndizes = [];
      root.querySelectorAll('input[data-sb-media-index]').forEach(function (input) {
        var i = parseInt(input.getAttribute('data-sb-media-index'), 10);
        if (!isNaN(i)) setIndizes.push(i);
      });

      gruppen.forEach(function (g) {
        var liste = g.eintraege;
        var erstes = liste[0] ? liste[0].querySelector('img') : null;
        merken(erstes);

        setIndizes.forEach(function (i) {
          var eintrag = liste[i];
          if (!eintrag) return;
          var img = eintrag.querySelector('img');
          merken(img);
          var istAktiv = gewaehlt && i === aktiv;
          // Das Set-Dia bleibt immer unsichtbar: sein Bild steht ja vorne an Position 1.
          // Die Markierung braucht es, weil die Vollbild-Kacheln in schnorv-pdp.css
          // "display: flex !important" tragen - dagegen kommt ein Inline-Stil nicht an.
          eintrag.style.display = 'none';
          eintrag.setAttribute('data-sb-hidden', '1');
          if (istAktiv && erstes && img) {
            setzen(erstes, img.dataset.sbOrig, img.dataset.sbOrigSet);
          }
        });

        if (!gewaehlt) zurueck(erstes);
      });
    }

    // Die Sticky-Leiste hängt normalerweise am Varianten-Wähler, den wir nicht benutzen. Darum hier
    // von Hand nachziehen: Name des Sets, Preis, Streichpreis und die Varianten-ID zum Kaufen.
    function setMoney(el, value) {
      if (!el) return;
      var hidden = el.querySelector('.visually-hidden');
      el.textContent = value;
      if (hidden) el.insertBefore(hidden, el.firstChild);
    }

    function syncSticky(checked) {
      var bar = document.querySelector('sticky-add-to-cart');
      if (!bar) return;
      bar.dataset.currentVariantId = checked.getAttribute('data-sb-variant');
      var title = bar.querySelector('.sticky-add-to-cart__variant');
      if (title) {
        title.textContent = checked.getAttribute('data-sb-title') || '';
        title.style.display = '';
      }
      var price = bar.querySelector('.sticky-add-to-cart__price');
      if (!price) return;
      var groups = price.querySelectorAll('.price-item__group');
      var now = null, was = null;
      for (var i = 0; i < groups.length; i++) {
        if (groups[i].classList.contains('compare-at-price')) was = groups[i];
        else if (!now) now = groups[i];
      }
      setMoney(now, checked.getAttribute('data-sb-price') || '');
      var compare = checked.getAttribute('data-sb-compare') || '';
      if (was) {
        if (compare) { setMoney(was, compare); was.style.display = ''; }
        else { was.style.display = 'none'; }
      }
    }
    // Desktop: Oberkante der Set-Auswahl auf die Unterkante des Hauptbilds legen (Bildhöhe hängt von der
    // Spaltenbreite ab, der Text darüber nicht — darum per Messung statt festem Abstand).
    function align(root) {
      if (!root.hasAttribute('data-sb-align')) return;
      if (window.innerWidth < 750) { root.style.marginTop = ''; return; }
      var section = root.closest('.shopify-section') || document;
      var media = section.querySelector('.product-information__media slideshow-slides, .product-information__media .product-media');
      if (!media) return;
      var scroller = document.querySelector('.page-wrapper');
      var scrolled = (scroller && scroller.scrollTop > 0) || window.scrollY > 0;
      if (scrolled && root.dataset.sbAligned) return; // nichts Klebriges nachmessen
      var column = root.parentElement;
      root.style.marginTop = '';
      if (column) column.style.paddingTop = '';
      var base = parseFloat(getComputedStyle(root).marginTop) || 0;
      var delta = media.getBoundingClientRect().bottom - root.getBoundingClientRect().top;
      if (delta <= 0) return;
      // Die Hälfte des Abstands wandert über Titel, Preis und Text, damit der Block nicht allein hängt
      var above = Math.round(delta * 0.5);
      if (column) column.style.paddingTop = above + 'px';
      root.style.marginTop = Math.round(base + delta - above) + 'px';
      root.dataset.sbAligned = '1';
    }
    function init() {
      document.querySelectorAll('[data-schnorv-bundle]').forEach(function (root) {
        if (root.dataset.sbReady) return;
        root.dataset.sbReady = '1';
        root.addEventListener('change', function () { root.dataset.sbUserPicked = '1'; apply(root); });
        // Klick auf die bereits gewählte Karte löst kein change aus — Bild soll trotzdem erscheinen
        root.addEventListener('click', function (e) {
          if (!e.target.closest('[data-sb-opt]')) return;
          root.dataset.sbUserPicked = '1';
          setTimeout(function () { apply(root); }, 0);
        });
        apply(root);
        align(root);
        var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(function () { align(root); }, 120); });
        var st;
        // Beim Scrollen NUR die Sticky-Leiste nachziehen. Frueher lief hier apply(), das die
        // Galerie zurueckgesprungen hat, sobald man im Karussell weitergewischt hat.
        document.addEventListener('scroll', function () {
          clearTimeout(st);
          st = setTimeout(function () {
            var checked = root.querySelector('input[data-sb-variant]:checked');
            if (checked) syncSticky(checked);
          }, 150);
        }, true);
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { align(root); });
        var tries = 0;
        var mediaTimer = setInterval(function () {
          tries++;
          applySetMedia(root);
          if (tries > 15) clearInterval(mediaTimer);
        }, 300);
        window.addEventListener('load', function () { align(root); });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:block:select', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
